import { t } from "i18next";
import PriceListSubTypes from "../pages/HIS/PriceListSubTypes";
import PriceListTypes from "../pages/HIS/PriceListTypes";
import { formatDate } from "../utils/FormateDateTime";
import { sequenceTableTemplate, statusTemplate } from "../utils/squenceTableNo";
import { getLowStockMessage, isLowStockItem } from "../utils/StockAlerts";

export const PriceListTypesTabs = (
  t,
  ishaveGettypePermission,
  ishaveGetSubtypePermission
) => ({
  tabs: [
    ishaveGettypePermission && {
      name: t("PRICELISTTYPES"),
      content: <PriceListTypes />,
    },
    ishaveGetSubtypePermission && {
      name: t("PRICELISTSUBTYPES"),
      content: <PriceListSubTypes />,
    },
  ],
});

export const priceListTypesTableColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    field: "name_en",
    header: t("NameEN"),
  },
  {
    field: "name_ar",
    header: t("NameAR"),
  },
  // {
  //   field: "category",
  //   header: t("Category"),
  // },
  {
    field: "is_active",
    header: t("Active"),
  },
];

export const priceListSubTypesTableColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    field: "name_en",
    header: t("NameEN"),
  },
  {
    field: "name_ar",
    header: t("NameAR"),
  },
  {
    field: "type",
    header: t("Type"),
    body: (rowData) => rowData?.price_list_type?.name_en,
  },
  {
    field: "is_active",
    header: t("Active"),
  },
];

export const priceListItemsTableColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    field: "price_list_type.name_en",
    header: t("Type"),
  },
  {
    field: "department.name_en",
    header: t("Department"),
  },
  {
    field: "effective_date",
    header: t("effective_date"),
    body: (rowData) => formatDate(rowData?.effective_date),
  },
  {
    field: "end_date",
    header: t("end_date"),
    body: (rowData) => formatDate(rowData?.expire_date),
  },
  {
    field: "non_standard_code",
    header: t("NonStandardCode"),
  },
  {
    field: "non_standard_description",
    header: t("Non Standard Description"),
  },
  // {
  //   field: "standard_code",
  //   header: t("StandardCode"),
  // },
  // {
  //   field: 'standard_description',
  //   header: t('StandardDescription')
  // },
  {
    field: "master_price",
    header: t("master_price"),
  },
  {
    field: "stock",
    header: t("Stock"),
    body: (rowData) =>
      rowData?.is_stock ? (
        <span className={rowData?.stock <= 2 ? "font-semibold text-red-800" : ""}>
          {rowData?.stock <= 2 ? `Low Stock (${rowData?.stock ?? 0})` : rowData?.stock ?? 0}
        </span>
      ) : (
        "-"
      ),
  },
  {
    field: "is_consumable",
    header: t("Consumable"),
    body: (rowData) => (rowData?.is_consumable ? t("Yes") : t("No")),
  },
  {
    field: "op_price",
    header: t("out_patient_price"),
  },
  {
    field: "ip_price",
    header: t("in_patient_price"),
  },
  {
    field: "emergency_price",
    header: t("emergency_patient_prcie"),
  },
  // {
  //   field: 'item_type',
  //   header: t('item_type')
  // },
  {
    field: "price_list_sub_type.name_en",
    header: t("subType"),
  },
];

export const priceListTypesOptionsFormatCategory = (response) => {
  return response?.map((data) => {
    return {
      label: data?.name_en,
      value: data?.id,
      item: data,
    };
  });
};
export const priceListTypesOptionsFormat = (response) => {
  return response?.map((data) => {
    return {
      label: data?.name_en,
      value: data?.id,
      item: data,
    };
  });
};
export const priceListTypesOptionsFormatForOrderItems = (response) => {
  return response?.map((data) => {
    return {
      label: data?.name_en,
      value: data?.id,
      item: data,
    };
  });
};

export const payerListTableColumns = (t) => [
  {
    name: t("payer"),
    key: "payer_name_en",
    colType: "field",
    type: "text",
    width: "min-w-[320px]",
    disabled: true,
  },
  {
    name: t("price"),
    key: "payer_price",
    colType: "field",
    type: "number",
    width: "min-w-[130px]",
    inputClassName: "min-w-[110px]",
  },
  {
    name: t("Nphies Code"),
    key: "nphies_code",
    colType: "field",
    type: "text",
  },
  {
    name: t("agreed_code"),
    key: "agreed_code",
    colType: "field",
    type: "text",
  },
  {
    name: t("agreed_description"),
    key: "agreed_description_en",
    colType: "field",
    type: "text",
  },
  {
    name: t("Agreed Description (AR)"),
    key: "agreed_description_ar",
    colType: "field",
    type: "text",
  },
  {
    name: t("discount_amount"),
    key: "discount_amount",
    colType: "field",
    type: "number",
  },
  {
    name: t("discount_percent"),
    key: "discount_percentage",
    colType: "field",
    type: "number",
  },
  {
    name: t("effective_date"),
    key: "effective_date",
    colType: "field",
    type: "date",
  },
  {
    name: t("end_date"),
    key: "expire_date",
    colType: "field",
    type: "date",
  },
  {
    name: t("Is Approval"),
    key: "is_approval",
    colType: "switch",
    type: "text",
  },
  // {
  //   name: "Is Master Price",
  //   key: "is_master_price",
  //   colType: "switch",
  //   type: "text",
  // },
  { name: t("Actions"), colType: "actions", type: "number" },
];

export const priceListStatusOptions = [
  { label: "Active", value: "active" },
  { label: "In Active", value: "in-active" },
];

export const priceListItemTypeOptions = [
  { label: "Cash", value: "cash" },
  { label: "Insurance", value: "insurance" },
];

export const labTubeOptions = [
  { label: "Red Top (Serum)", value: "red_top" },
  { label: "Blue Top (Citrate)", value: "blue_top" },
  { label: "Green Top (Heparin)", value: "green_top" },
  { label: "Purple Top (EDTA)", value: "purple_top" },
  { label: "Yellow Top (SST)", value: "yellow_top" },
  { label: "Gray Top (Fluoride)", value: "gray_top" },
  { label: "Black Top (ESR)", value: "black_top" },
  { label: "Pink Top (Blood Bank)", value: "pink_top" },
  { label: "Tan Top (Lead Testing)", value: "tan_top" },
  { label: "White Top (PCR)", value: "white_top" },
];

export const packageTypeOptions = [
  { label: "Surgical", value: "surgical" },
  { label: "Lab", value: "lab" },
  { label: "Rad", value: "rad" },
  { label: "Out Patient", value: "out_patient" },
  { label: "In Patient", value: "in_patient" },
];

export const standardCodeOptions = (response) => {
  return response?.map((data) => {
    return {
      label: data?.description + " - " + data?.code,
      value: data?.code,
      data: data,
    };
  });
};

export const labsForms = [];

export const itemListGeneralInfo = (data, t) => [
  {
    label: t("Type"),
    text: data?.price_list_type?.name_en,
  },
  {
    label: t("subType"),
    text: data?.price_list_sub_type?.name_en,
  },
  {
    label: t("Department"),
    text: data?.department?.name_en,
  },
  {
    label: t("Standard Code"),
    text: data?.standard_code,
  },
  {
    label: t("StandardDescription"),
    text: data?.standard_description,
  },
  {
    label: t("NonStandardCode"),
    text: data?.non_standard_code,
  },
  {
    label: t("Non Standard Description"),
    text: data?.non_standard_description,
  },
  {
    label: t("master_price"),
    text: data?.master_price,
  },
  {
    label: t("Consumable"),
    text: data?.is_consumable ? t("Yes") : t("No"),
  },
  {
    label: t("item_type"),
    text: data?.item_type,
  },
  {
    label: t("effective_date"),
    text: formatDate(data?.effective_date),
  },
  {
    label: t("end_date"),
    text: formatDate(data?.expire_date),
  },
];

export const priceInPatient = (data, t) => [
  {
    label: t("item_price"),
    text: data?.ip_price,
  },
  {
    label: t("internal_cost"),
    text: data?.ip_internal_cost,
  },
  {
    label: t("discount_amount"),
    text: data?.ip_discount_amount,
  },
  {
    label: t("discount_percent"),
    text: data?.ip_discount_percentage,
  },
];
export const priceemergency = (data, t) => [
  {
    label: t("item_price"),
    text: data?.emergency_price,
  },
  {
    label: t("internal_cost"),
    text: data?.emergency_internal_cost,
  },
  {
    label: t("discount_amount"),
    text: data?.emergency_discount_amount,
  },
  {
    label: t("discount_percent"),
    text: data?.emergency_discount_percentage,
  },
];
export const priceOutPatient = (data, t) => [
  {
    label: t("item_price"),
    text: data?.op_price,
  },
  {
    label: t("internal_cost"),
    text: data?.op_internal_cost,
  },
  {
    label: t("discount_amount"),
    text: data?.op_discount_amount,
  },
  {
    label: t("discount_percent"),
    text: data?.op_discount_percentage,
  },
];
export const costManagement = (data, t) => [
  {
    label: t("Price"),
    text: data?.manage_costs?.price,
  },
  {
    label: t("Code"),
    text: data?.manage_costs?.code,
  },
  {
    label: t("Type"),
    text: data?.manage_costs?.type,
  },
  {
    label: t("Description"),
    text: data?.manage_costs?.description,
  },
];
export const manageCostsTableColumns = (t) => [
  { name: t("Type"), key: "type", type: "dropdown", colType: "field" },
  { name: t("Code"), key: "code", type: "text", colType: "field" },
  { name: t("Price"), key: "price", type: "number", colType: "field" },
  {
    name: t("Description"),
    key: "description",
    type: "text",
    colType: "field",
  },
  { name: t("Actions"), colType: "actions" },
];

export const manageCostsTableColumnsReadOnly = (t) => [
  { name: t("Type"), key: "type", type: "dropdown", colType: "field" },
  { name: t("Code"), key: "code", type: "text", colType: "field" },
  { name: t("Price"), key: "price", type: "number", colType: "field" },
  {
    name: t("Description"),
    key: "description",
    type: "text",
    colType: "field",
  },
];


export const payersTableColumnsData = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    header: t("PayerID"),
    body: (rowData) => rowData?.payer?.payer_id,
  },
  {
    header: t("Name"),
    body: (rowData) => rowData?.payer?.name,
  },
  {
    header: t("Type"),
    body: (rowData) => rowData?.payer?.type,
  },
  {
    header: t("LicenseID"),
    body: (rowData) => rowData?.payer?.license_id,
  },
  {
    header: t("price"),
    body: (rowData) => rowData?.payer_price,
  },
  {
    header: t("Nphies Code"),
    body: (rowData) => rowData?.nphies_code,
  },
  {
    header: t("agreed_code"),
    body: (rowData) => rowData?.non_standard_code,
  },
  {
    header: t("agreed_description"),
    body: (rowData) => rowData?.non_standard_description,
  },
  {
    header: t("discount_amount"),
    body: (rowData) => rowData?.discount_amount,
  },
  {
    header: t("discount_percent"),
    body: (rowData) => rowData?.discount_percentage,
  },
  {
    header: t("effective_date"),
    body: (rowData) => formatDate(rowData?.effective_date),
  },
  {
    header: t("end_date"),
    body: (rowData) => formatDate(rowData?.expire_date),
  },
];
export const packageTableColumnsData = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    header: t("Item Code"),
    body: (rowData) => rowData?.non_standard_code,
  },
  {
    header: t("Item Name"),
    body: (rowData) => rowData?.non_standard_description,
  },
];
export const manageCostsDetailTableColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
  },
  {
    header: t("Code"),
    field: "code",
  },
  {
    header: t("Type"),
    field: "type",
  },
  {
    header: t("Price"),
    body: (rowData) => rowData?.price,
  },
  {
    header: t("Description"),
    body: (rowData) => rowData?.description,
  },
];

export const packageItemColumns = (t) => [
  {
    header: t("No"),
    body: sequenceTableTemplate,
    style: { width: "3rem" },
  },
  {
    header: t("Item Code"),
    field: "non_standard_code",
  },
  {
    header: t("ItemName"),
    field: "non_standard_description",
  },
];
